export default "__VITE_ASSET__8468f981__$_?nuxt_component=async&nuxt_component_name=SvgoFamous__"